import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core'
import { DecimalPipe, NgForOf, NgIf } from '@angular/common'
import { TranslateModule } from '@ngx-translate/core'

@Component({
  selector: 'app-stars-rating',
  standalone: true,
    imports: [
        NgForOf,
        DecimalPipe,
        NgIf,
        TranslateModule
    ],
  templateUrl: './stars-rating.component.html',
  styleUrl: './stars-rating.component.scss'
})
export class StarsRatingComponent implements OnInit{

    @Input() isInteractive: boolean = false; // Default to non-interactive
    @Input() maxStars: number = 5; // Default maximum stars
    @Input() rating: number = 0; // Default rating value

    @Output() selectedRatingChange = new EventEmitter<number>();

    hoverRating: number = 0; // For hover effect

    stars: ('none' | 'half' | 'full')[] = [];

    ngOnInit() {
        this.stars = this.calculateStars();
    }

    calculateStars(): ('none' | 'half' | 'full')[] {
        const stars: ('none' | 'half' | 'full')[] = []

        for(let i = 0; i < this.maxStars; i++) {
            if ((this.hoverRating || this.rating) >= i + 1) {
                stars.push('full'); // Full star
            } else if ((this.hoverRating || this.rating) > i && (this.hoverRating || this.rating) < i + 1) {
                stars.push('half'); // Half star
            } else {
                stars.push('none'); // No star
            }
        }

        return stars;
    }

    getArrayUpTo(max: number): number[] {
        return Array.from({ length: max }, (_, i) => i);
    }

    setHover(valor: number): void {
        this.hoverRating = valor;
    }

    clearHover(): void {
        this.hoverRating = 0;
    }

    onSelectedRating(index: number): void {
        this.rating = index;
        this.selectedRatingChange.emit(this.rating);
    }

}
